__turbopack_context__.v({
  "navigation": "Tabs-module-scss-module__tUNwAG__navigation",
  "panel": "Tabs-module-scss-module__tUNwAG__panel",
  "tabLink": "Tabs-module-scss-module__tUNwAG__tabLink",
  "tabLinkActive": "Tabs-module-scss-module__tUNwAG__tabLinkActive",
  "tabLinkText": "Tabs-module-scss-module__tUNwAG__tabLinkText",
  "tabs": "Tabs-module-scss-module__tUNwAG__tabs",
});
